module.exports = __webpack_public_path__ + "static/media/three-am.985d6287.mp3";